// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"3ec60cff","38":"8750dc52","177":"906a44c9","325":"3ec60cff","475":"6865eef5","678":"96c31b9c","721":"916d324c"}[chunkId] + ".chunk.css";
};